export default __webpack_public_path__ + "static/media/gallery.479221cb.svg";